﻿<script setup lang="ts"></script>

<template>
    <section>
        <router-view></router-view>
    </section>
</template>

<style></style>
